// let config = require('../static/config')

module.exports = {
  // 生产环境配置
  // test:false,
  // nname:'', //默认登录用户名
  // ddurl:'http://117.156.130.112:7000/ding.php',
  // ddcorpid:'dinge0e0800f374d185335c2f4657eb6378f',

  // 登录页logo
  // logourl: 'logo.png', //迪迈图标
  logourl: 'logo-zh.png', //中核图标
  logourlzsgly: 'logo-zgys.png', //桂林院图标
  // /*测试
  test: false, // 是否是测试环境
  devname: '管理员', //测试默认登录用户名
  project: 'zsgly',
  // php获取用户信息
  // ddurl: 'http://' + config.ipName + '/ding.php',
  ddurl: '/deptDingTalkController/getUserByCode',
  // 企业微信认证接口
  qywxurl: '/qiyewx/getUserByCode',
  // 移动五矿认证接口
  // qywxurl: '/wk4a/getUserByCode',
  // apiurl: 'http://222.83.237.154:8090/api',
  // apiurl: 'http://127.0.0.1:8088',
  // 企业微信环境 马坑环境  云锡环境  非矿环境
  apiurl: '/api',
  // 测试外网配置
  // apiurl: 'http://192.168.123.35:8088',
  // ddcorpid: 'ding65ab554ca0a27b76ee0f45d8e4f7c278'
  // 生产环境 钉钉  龙首正式环境
  // apiurl:'http://117.156.130.112:8088',
  // ddcorpid:'dinge0e0800f374d185335c2f4657eb6378f'
  //*/
}



// WEBPACK FOOTER //
// ./src/yhconfig.js